import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2, XCircle } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function ClosingCTA() {
  return <section className="w-full bg-cream-dark py-20 px-6 pb-32" data-id="element-1">
      <div className="max-w-reading mx-auto space-y-24" data-id="element-2">
        {/* Who this is for */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="grid md:grid-cols-2 gap-8" data-id="element-3">
          <div className="bg-white p-8 rounded-xl shadow-sm border-t-4 border-teal" data-id="element-4">
            <h3 className="font-serif text-2xl font-bold mb-6 text-teal-dark" data-id="element-5">
              This is for you if:
            </h3>
            <ul className="space-y-4" data-id="element-6">
              {["you're a woman 30+ carrying a lot", 'you feel high-functioning but internally braced', "you've tried generic calm advice and it didn't stick", "you want something you can finish, even when you're tired"].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-7">
                  <CheckCircle2 className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-8" />
                  <span className="text-charcoal" data-id="element-9">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-cream p-8 rounded-xl border border-charcoal/10" data-id="element-10">
            <h3 className="font-serif text-2xl font-bold mb-6 text-charcoal-muted" data-id="element-11">
              This is not for you if:
            </h3>
            <ul className="space-y-4" data-id="element-12">
              {["you want deep trauma processing (that's therapy territory)", 'you want a long spiritual program', 'you want a plan that adds more pressure to your life'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-13">
                  <XCircle className="w-5 h-5 text-charcoal-muted/50 mt-1 flex-shrink-0" data-id="element-14" />
                  <span className="text-charcoal-muted" data-id="element-15">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        {/* Simplest Way to Start */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="text-center space-y-6" data-id="element-16">
          <h2 className="font-serif text-3xl md:text-4xl font-bold" data-id="element-17">
            The simplest way to start
          </h2>
          <p className="text-xl text-charcoal-muted" data-id="element-18">
            You don't need to fix your whole life this week.
          </p>
          <p className="text-xl" data-id="element-19">
            You just need one small protocol that tells your body:
          </p>
          <p className="font-serif text-2xl italic text-teal-dark font-medium" data-id="element-20">
            "We can be safe without being on."
          </p>
          <p className="text-lg pt-4" data-id="element-21">
            If you're ready to stop living in alarm mode, start here.
          </p>
        </motion.div>

        {/* Main CTA */}
        <motion.div id="cta" initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-amber/20 text-center space-y-8 max-w-3xl mx-auto relative overflow-hidden" data-id="element-22">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-teal via-amber to-teal" data-id="element-23" />

          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-24">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-25">
              <img src="https://cdn.magicpatterns.com/uploads/2RMsKd7V3WWoHwDSJZJpe1/heylloyd-image-1770798720501.png" alt="Ebook Cover" className="w-full rounded-lg shadow-lg transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-26" />
            </div>

            <div className="flex-1 text-left space-y-6" data-id="element-27">
              <h3 className="font-serif text-3xl font-bold text-charcoal" data-id="element-28">
                Get The 7-Day Minimum Viable Calm Reset now.
              </h3>

              <ul className="space-y-2 text-lg text-charcoal-muted" data-id="element-29">
                <li className="flex items-center gap-2" data-id="element-30">
                  <span className="w-1.5 h-1.5 rounded-full bg-teal" data-id="element-31" />
                  10 minutes a day
                </li>
                <li className="flex items-center gap-2" data-id="element-32">
                  <span className="w-1.5 h-1.5 rounded-full bg-teal" data-id="element-33" />7 days
                </li>
                <li className="flex items-center gap-2" data-id="element-34">
                  <span className="w-1.5 h-1.5 rounded-full bg-teal" data-id="element-35" />
                  Plus a 90-second rescue protocol for spikes
                </li>
              </ul>

              <Button fullWidth className="text-lg md:text-xl py-5" href="https://www.versastorex.com/cart/42003489685584:1" data-id="element-36">
                <span className="flex flex-col items-center gap-1" data-id="element-37">
                  <span data-id="element-38">Get The 7-Day Minimum Viable Calm Reset</span>
                  <span className="flex items-center gap-2 text-sm" data-id="element-39">
                    <span className="line-through opacity-60" data-id="element-40">$21.30</span>
                    <span className="font-bold text-base" data-id="element-41">$6.39</span>
                    <span className="bg-white/20 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-42">
                      -70%
                    </span>
                  </span>
                </span>
              </Button>
            </div>
          </div>
        </motion.div>

        {/* Final Note */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="text-center max-w-xl mx-auto pt-12 space-y-6" data-id="element-43">
          <div className="w-16 h-px bg-gray-300 mx-auto" data-id="element-44" />
          <p className="font-serif text-xl italic text-charcoal-muted leading-relaxed" data-id="element-45">
            You've been strong for a long time. <br data-id="element-46" />
            But strength without recovery turns into a cost you pay every day.
          </p>
          <p className="font-bold text-teal-dark text-lg" data-id="element-47">
            This is how you start paying less.
          </p>
        </motion.div>
      </div>
    </section>;
}